
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("32x2E", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5B7Fh = parcelRequire("5B7Fh");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $5B7Fh.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("5B7Fh", function(module, exports) {

var $eTj7Y = parcelRequire("eTj7Y");


var $fhsiz = parcelRequire("fhsiz");


var $i0VEL = parcelRequire("i0VEL");

class $57ed069fa0b7e304$export$67106c51beb59865 extends (0, $i0VEL.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $eTj7Y.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $eTj7Y.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $fhsiz.defaultEmojiHeight),
                    width: (0, $fhsiz.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $57ed069fa0b7e304$export$67106c51beb59865;

});

parcelRegister("di8q4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("9VfGx"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fT2ta = parcelRequire("fT2ta");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $frIzR.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $gMc0m.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("9VfGx", function(module, exports) {

let $73959aa95cc83a91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $73959aa95cc83a91$var$load("dVY98"),
    $73959aa95cc83a91$var$load("jKuFd"),
    $73959aa95cc83a91$var$load("6wr18"),
    $73959aa95cc83a91$var$load("ffEVr"),
    $73959aa95cc83a91$var$load("kjZZD"),
    $73959aa95cc83a91$var$load("ajMch"),
    $73959aa95cc83a91$var$load("hxlWB"),
    $73959aa95cc83a91$var$load("4izLy"),
    $73959aa95cc83a91$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("g5QRf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb761d6fd7d44f19$var$_react = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("42omo")));

var $bb761d6fd7d44f19$var$_baseNew = $bb761d6fd7d44f19$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $bb761d6fd7d44f19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $bb761d6fd7d44f19$var$_react.default.createElement($bb761d6fd7d44f19$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$bb761d6fd7d44f19$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $bb761d6fd7d44f19$var$_default = module.exports.default = $bb761d6fd7d44f19$var$AiGenerativeSlidesIcon;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("18R9N", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $42omo.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("7boqA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $42omo.useCallback)(()=>{
        (0, $kGwvc.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});


//# sourceMappingURL=LabelsSelect.5467bda3.js.map
